import React, { Fragment, useEffect, useRef } from "react";
import { translate } from "../../Services/translation";

const ProductUnitChangeModal = ({ onCancel, onConfirm }) => {
    const ref = useRef(null);
    let focusableElements;
    let index = 1;

    const handleCancel = () => {
        onCancel();
    };
    const handleConfirm = () => {
        onConfirm();
    };

    const handleTab = (e) => {
        const { shiftKey } = e;
        let total = focusableElements.length;

        if (shiftKey) index = index - 1 < 0 ? total - 1 : index - 1;
        if (!shiftKey) index = index + 1 === total ? 0 : index + 1;

        focusableElements[index].focus();

        return e.preventDefault();
    };

    const handleKeydown = (e) => {
        const listener = keyMap.get(e.keyCode);
        return listener && listener(e);
    };

    const handleInnerClick = (e) => {
        e.stopPropagation();
    };

    const keyMap = new Map([
        [27, handleCancel],
        [9, handleTab],
    ]);

    useEffect(() => {
        if (ref.current) {
            focusableElements = ref.current.querySelectorAll("button");
            ref.current.focus();
        }
    }, [ref]);

    return (
        <div
            className="pucm"
            tabIndex="-1"
            ref={ref}
            onKeyDown={handleKeydown}
            onClick={handleCancel}
        >
            <div className="pucm__wrapper" onClick={handleInnerClick}>
                <div className="pucm__container">
                    <p>{translate("product.notice.unitchanged")}</p>
                    <button
                        className="cancel"
                        onClick={handleCancel}
                        tabIndex="0"
                    >
                        {translate("product.notice.cancel")}
                    </button>
                    <button className="confirm" onClick={handleConfirm}>
                        {translate("product.notice.confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductUnitChangeModal;
